export { default } from "./src/split-color-background-container";
export type { UniformSplitColorBackgroundContainerProps } from "./src/split-color-background-container";
